import React from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

const INSTRUCTION_PHASE_SUBMIT_NOOP = () => {};

/**
 * During modeling (isInstruction) the button looks interactive but onClick is a no-op;
 * disabled when no option selected to mirror real usage.
 */
export default function MmcSubmitButton({
  submitIconSize,
  hideSubmit,
  pointerTarget,
  isInstruction,
  isRepeating,
  hasSelection,
  submitEnabled,
  onSubmit,
}) {
  return (
    <AmiraIconButton
      {...submitIconSize}
      type={ICON_BUTTON_TYPES.SUBMIT}
      oblong
      onClick={
        isInstruction
          ? INSTRUCTION_PHASE_SUBMIT_NOOP
          : () => !isRepeating && submitEnabled && onSubmit()
      }
      disabled={isInstruction ? !hasSelection : !submitEnabled || isRepeating}
      invisible={hideSubmit}
      pointerPosition="left"
      showPointer={pointerTarget === 'submit'}
    />
  );
}
